import { forwardRef as m } from "react";
import { Flex as c } from "theme-ui";
import { jsx as n } from "theme-ui/jsx-runtime";
const s = m((t, e) => {
  const {
    direction: r = "column",
    gap: i = 0,
    ...o
  } = t;
  return /* @__PURE__ */ n(c, {
    ...o,
    ref: e,
    sx: {
      flexDirection: r,
      gap: i,
      ...r === "row" && {
        alignItems: "center"
      },
      ...o.sx
    }
  });
});
s.displayName = "Stack";
export {
  s as Stack
};
